<template>
  <section class="fo-card">
    <div class="fo-card-loading loading loading-lg" v-if="loading"></div>
    <div class="fo-card-head">
      <h2 class="fo-card-title">
        Próximos vencimentos<small>próximas 4 semanas, em aberto</small>
      </h2>
      <button type="button" class="fo-link" @click="table = !table">
        {{ table ? 'Ver gráfico' : 'Ver como tabela' }}
      </button>
    </div>
    <div class="fo-legend">
      <span><i class="fo-legend-revenue"></i>Receita em aberto</span>
      <span><i class="fo-legend-expense"></i>Despesa em aberto</span>
    </div>

    <table class="table fo-table" v-if="table">
      <thead>
        <tr>
          <th>Semana</th>
          <th class="text-right">Receita em aberto</th>
          <th class="text-right">Despesa em aberto</th>
          <th class="text-right">Saldo no fim</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="week in weeks" :key="week.start">
          <td>{{ weekLabel(week) }}</td>
          <td class="text-right">{{ money(week.revenue) }}</td>
          <td class="text-right">{{ money(week.expense) }}</td>
          <td class="text-right">{{ money(week.balance) }}</td>
        </tr>
      </tbody>
    </table>

    <grouped-bars v-else :groups="groups" :hidden="hidden" :height="190">
      <template v-slot:tip="{ group }">
        <strong>{{ group.label }}</strong>
        <div class="fo-tip-row">
          <span><i class="fo-dot fo-dot-revenue"></i>Receita</span>
          <b>{{ money(group.revenue) }}</b>
        </div>
        <div class="fo-tip-row">
          <span><i class="fo-dot fo-dot-expense"></i>Despesa</span>
          <b>{{ money(group.expense) }}</b>
        </div>
        <div class="fo-tip-row fo-tip-total">
          <span>Saldo no fim</span><b>{{ money(group.balance) }}</b>
        </div>
      </template>
    </grouped-bars>
  </section>
</template>

<script>
import GroupedBars from './GroupedBars.vue';
import { compact, money, shortDate } from './helpers';

export default {
  components: {
    GroupedBars,
  },
  props: {
    weeks: {
      type: Array,
      default: () => [],
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      table: false,
    };
  },
  computed: {
    groups() {
      return this.weeks.map(week => ({
        key: week.start,
        label: this.weekLabel(week),
        note: `saldo no fim ${this.balanceLabel(week.balance)}`,
        revenue: week.revenue,
        expense: week.expense,
        balance: week.balance,
      }));
    },
  },
  methods: {
    money(value) {
      return money(value, this.hidden);
    },
    weekLabel(week) {
      return `${shortDate(week.start)} – ${shortDate(week.end)}`;
    },
    balanceLabel(value) {
      if (this.hidden) {
        return 'R$ •••';
      }
      return `${value < 0 ? '−' : ''}R$ ${compact(Math.abs(value))}`;
    },
  },
};
</script>
